import React from "react";
import NotificationCard from "./NotificationCard";
import { List } from "antd";
import "./notification.css";
import { useRecoilValue } from "recoil";
import { notifications } from "../../../components/recoil/notificationsRecoil";

const NotificationList = () => {
  const notificationList = useRecoilValue(notifications);

  return (
    <>
      <List
        dataSource={notificationList}
        renderItem={(item) => <NotificationCard data={item} key={item?.id} />}
      />
    </>
  );
};

export default NotificationList;
